import { BlocksProps } from '@/lib/wordpress/_types/blocksStyle'
import React from 'react'
import classNames from 'classnames'
import displayBlock from '@/lib/wordpress/blocks/displayBlock'
import getBlockStyles from '@/lib/wordpress/blocks/getBlockStyles'

export type IBlockGroup = {
  attrs: {
    anchor?: string
    tagName?: string
    backgroundColor?: string
    textColor?: string
    className?: string
    style?: Record<string, unknown>
    animation?: string;
  }
  innerBlocks?: BlocksProps[]
}

export default function BlockGroup({ attrs, innerBlocks }: IBlockGroup) {
  const { anchor, tagName, backgroundColor, textColor, className, style, animation } = attrs

  const groupStyle = getBlockStyles({
    textColor,
    backgroundColor,
    style
  })

  return React.createElement(
    tagName as string,
    {
      className: classNames('block-group', className?.replace('is-style-rounded', 'radius-md shadow-sm'), animation && `elements_animated ${animation}`),
      id: anchor,
      style: {
        ...groupStyle,
        overflow: 'hidden'
      }
    },
    !!innerBlocks?.length &&
      innerBlocks.map((block: BlocksProps, index: number) => {
        return displayBlock(block as BlocksProps, index)
      })
  )
}
